export default __webpack_public_path__ + "static/media/Mycloudwallet.dafd34c8.png";